<template>
  <div class="withdraw">
    <div class="withdraw-btn" :class="{'opciaty': !disabled}" @click="toWithdrawSettlement">去提现</div>
  </div>
</template>
<script>

export default {
  name: 'withdraw-button',
  props: ['disabled'],
  methods: {
    toWithdrawSettlement () {
      var current = this;
      if (current.disabled) {
        this.$router.push('/account/withdrawSettlement')
      }
    }
  }
}
</script>
<style scoped>
  .withdraw{
    width: 100%;
    min-height: 100%;
    height: auto;
    position: relative;
  }
  .withdraw-btn{
    width: 19.6875rem;
    height: 2.8125rem;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    background: linear-gradient(180.00deg, rgb(58, 126, 255),rgb(33, 109, 254) 100%);
    position: fixed;
    bottom: 3.125rem;
    left: calc(50% - 9.8438rem);
    border-radius: .25rem;
    z-index: 100;
  }
  .opciaty{
    opacity: 0.5;
  }
</style>



// WEBPACK FOOTER //
// src/components/withdraw-button.vue